import { render } from "./publicity.vue?vue&type=template&id=422b4ab9&scoped=true"
import script from "./publicity.vue?vue&type=script&lang=js"
export * from "./publicity.vue?vue&type=script&lang=js"

import "./publicity.vue?vue&type=style&index=0&id=422b4ab9&lang=scss&scoped=true"

import exportComponent from "D:\\jll-web-xintan\\xinfu-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-422b4ab9"]])

export default __exports__